module.exports = __webpack_public_path__ + "static/running-f77441bc43ace7c50b9e5f06ed22e0dc.jpg";